import React, { createRef, useState } from "react";
import { Modal } from "bootstrap";
import logo from '../leclab-madrid-vertical.png'
import { Link, useNavigate } from "react-router-dom";
import { registerWithEmailAndPassword } from "../services/firebase/firebase";
import { Policy } from "./modals";

function SignUp() {

    const [partner, setPartner] = useState({
        firstname: '',
        lastname: '',
        email: '',
        tlf: '',
        dni: '',
        password: '',
        company: '',
        role: '',
        dir: '',
        cp: '',
        city: '',
        state: '',
        country: '',
    })

    const [communication, setCommunication] = useState(false)
    const [privacy, setPrivacy] = useState(false)
    const [errors, setErrors] = useState({})

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const modalRef = createRef()

    const showModal = () => {
        const modalEle = modalRef.current
        const bsModal = new Modal(modalEle, {
            backdrop: false,
            keyboard: false
        })
        bsModal.show()
    }

    const hideModal = () => {
        const modalEle = modalRef.current
        const bsModal = Modal.getInstance(modalEle)
        bsModal.hide()
    }

    const makeChange = (e) => {
        var target = e.target.name
        var value = e.target.value
        setPartner({ ...partner, [target]: value })
    }

    const handleValidation = () => {
        setErrors({})
        //  Empty fields
        if (!partner?.firstname | !partner?.lastname | !partner?.dni | !partner?.email | !partner?.tlf | !partner?.password) {
            setErrors({ ...errors, error: 'Es necesario cumplimentar todos los campos' });
            return false
        }

        //  Invalid email
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/.test(partner.email)) {
            setErrors({ ...errors, error: 'Email no válido' })
            return false
        }

        //  DNI validation
        var numero
        var letr
        var letra
        var expresion_regular_dni

        expresion_regular_dni = /^\d{8}[a-zA-Z]$/;

        if (expresion_regular_dni.test(partner.dni) === true) {
            numero = partner.dni.substr(0, partner.dni.length - 1);
            letr = partner.dni.substr(partner.dni.length - 1, 1);
            numero = numero % 23;
            letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
            letra = letra.substring(numero, numero + 1);
            if (letra !== letr.toUpperCase()) {
                setErrors({ ...errors, error: 'Dni erroneo, la letra del NIF no se corresponde' });
                return false
            }
        } else {
            setErrors({ ...errors, error: 'Dni erroneo, formato no válido' });
            return false
        }

        //  Tlf length
        if (partner.tlf.length < 9) {
            setErrors({ ...errors, error: 'El número de teléfono no es válido' })
            return false
        }

        //  Password length
        if (partner.password.length < 9) {
            setErrors({ ...errors, error: 'La contraseña debe tener al menos 8 caracteres' })
            return false
        }

        return true
    }

    const doSignUp = (e) => {
        e.preventDefault()
        setLoading(true)
        if (handleValidation() === true) {
            registerWithEmailAndPassword(partner)
                .then(response => {
                    setLoading(false)
                    alert(response)
                    navigate("/")
                })
                .catch(error => {
                    switch (error.code) {
                        case 'auth/email-already-in-use':
                            alert(`El email ${partner.email} ya está en uso.`);
                            break;
                        case 'auth/invalid-email':
                            alert(`El email ${partner.email} no es válido.`);
                            break;
                        case 'auth/operation-not-allowed':
                            alert(`Error durante el registro.`);
                            break;
                        case 'auth/weak-password':
                            alert('Password is not strong enough. Add additional characters including special characters and numbers.');
                            break;
                        default:
                            console.log(error.message);
                            alert('Error durante el registro.')
                            break;
                    }
                })
        }
    };

    return (
        <div className="auth-wrapper">
            <div className="auth-inner">
                <div className="card-header bg-transparent">
                    <img width="100" className="mb-2" src={logo} />
                    <h3>Registro de Socio de Leclab</h3>
                </div>
                <form className="card-body text-start" style={{ height: 'calc(100% - 3.75rem)' }} onSubmit={doSignUp}>
                    <div className="row align-items-center justify-content-between my-3">
                        <div className="col-sm-12 mb-sm-2 col-md-6">
                            <input
                                type="text"
                                className="form-control"
                                name="firstname"
                                value={partner?.firstname}
                                onChange={makeChange}
                                placeholder="Nombre *"
                                required
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-2 col-md-6">
                            <input
                                type="text"
                                className="form-control"
                                name="lastname"
                                value={partner?.lastname}
                                onChange={makeChange}
                                placeholder="Apellidos *"
                                required
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-2 col-md-4">
                            <input
                                type="text"
                                className="form-control"
                                name="email"
                                value={partner?.email}
                                onChange={makeChange}
                                placeholder="Email *"
                                required
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-2 col-md-4">
                            <input
                                type="text"
                                className="form-control"
                                name="tlf"
                                value={partner?.tlf}
                                onChange={makeChange}
                                placeholder="Teléfono *"
                                required
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-2 col-md-4">
                            <input
                                type="text"
                                className="form-control"
                                name="dni"
                                value={partner?.dni}
                                onChange={makeChange}
                                placeholder="DNI/NIE/Pass *"
                                required
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-2 col-md-6">
                            <input
                                type="password"
                                className="form-control"
                                name="password"
                                value={partner?.password}
                                onChange={makeChange}
                                placeholder="Contraseña *"
                                required
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-2 col-md-6">
                            <span className="form-text">9 dig (M y m, nº y símbolos)</span>
                        </div>
                    </div>
                    <div className="row align-items-center mb-3">
                        <div className="col-sm-12 mb-sm-2 col-md-7">
                            <input
                                type="text"
                                className="form-control"
                                name="company"
                                value={partner?.company}
                                onChange={makeChange}
                                placeholder="Empresa"
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-2 col-md-5">
                            <input
                                type="text"
                                className="form-control"
                                name="role"
                                value={partner?.role}
                                onChange={makeChange}
                                placeholder="Profesión"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center mb-3">
                        <div className="col-sm-12 mb-sm-2 col-md-9">
                            <input
                                type="text"
                                className="form-control"
                                name="dir"
                                value={partner?.dir}
                                onChange={makeChange}
                                placeholder="Dirección"
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-2 col-md-3">
                            <input
                                type="text"
                                className="form-control"
                                name="cp"
                                value={partner?.cp}
                                onChange={makeChange}
                                placeholder="CP"
                            />
                        </div>
                        <div className="col-sm-12 mb-sm-2 col-md-4">
                            <input
                                type="text"
                                className="form-control"
                                name="city"
                                value={partner?.city}
                                onChange={makeChange}
                                placeholder="Ciudad"
                            />
                        </div>
                        <div className="col-sm-6 mb-sm-2 col-md-4">
                            <input
                                type="text"
                                className="form-control"
                                name="state"
                                value={partner?.state}
                                onChange={makeChange}
                                placeholder="Provincia"
                            />
                        </div>
                        <div className="col-sm-6 mb-sm-2 col-md-4">
                            <input
                                type="text"
                                className="form-control"
                                name="country"
                                value={partner?.country}
                                onChange={makeChange}
                                placeholder="País"
                            />
                        </div>
                    </div>
                    <div className="mb-3">
                        <div className="form-check">
                            <input type="checkbox" className="form-check-input" checked={communication} onChange={e => setCommunication(!communication)} />
                            <p className="form-check-label text-start">
                                Acepto recibir comunicaciones de Leclab
                            </p>
                        </div>
                        <div className="form-check">
                            <input type="checkbox" className="form-check-input" checked={privacy} onChange={e => setPrivacy(!privacy)} />
                            <p className="form-check-label text-start">
                                He leído y acepto la <span style={{ cursor: 'pointer', color: '#3366BB' }} onClick={() => showModal()}>Politica de Privacidad</span>
                            </p>
                        </div>
                    </div>
                    <div className="w-100">
                        {!loading && <button disabled={!privacy | !communication} type="submit" className="btn btn-login btn-block w-100">Enviar solicitud</button>}
                        {loading &&
                            <button className="btn btn-login btn-block w-100" type="button" disabled>
                                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                Loading...
                            </button>
                        }
                    </div>
                    <div className="mt-3 text-end">
                        Ya soy socio. <Link to="/" style={{ textDecoration: 'none' }}>Acceder</Link>
                    </div>
                    <Policy ref={modalRef} />
                </form>
                <div className="card-footer bg-transparent h-30">
                    {errors?.error && <p className="text-danger">{errors.error}</p>}
                </div>
            </div>
        </div>
    );
};

export default SignUp;
